module.exports = (__webpack_require__(7))(521);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/@angular/common/node_modules/tslib/tslib.es6.js from dll-reference vendor
// module id = 1209
// module chunks = 0